import qs from 'qs';
import mergeWith from 'lodash/mergeWith';
import cloneDeep from 'lodash/cloneDeep';

// qs leaves every value a string, so "only_deleted=false" would read as
// truthy and switch the filter on. Restore real booleans.
const decoder = (str, defaultDecoder, charset, type) => {
  const decoded = defaultDecoder(str, defaultDecoder, charset);
  if (type === 'value') {
    if (decoded === 'true') return true;
    if (decoded === 'false') return false;
  }
  return decoded;
};

// Copy of a search's defaults with every list emptied.
const withoutLists = (value) => {
  if (Array.isArray(value)) return [];
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((out, key) => {
      out[key] = withoutLists(value[key]);
      return out;
    }, {});
  }
  return value;
};

// Lay the URL's query over a search's defaults. A shared link only needs the
// filters it sets; the date range, amount bounds, paging and anything else it
// leaves out keep their defaults instead of disappearing (search bars read
// them unguarded, e.g. `where.grand_total.gte`).
//
// Multi-selects are the exception: qs drops empty arrays, so a status list
// the user cleared is simply absent from the URL. Once the URL says anything,
// default lists start empty so that clear survives a reload. A bare URL gets
// the full defaults.
export function searchFromQuery(defaults, query) {
  if (!query) return cloneDeep(defaults || {});
  const parsed = qs.parse(query, { decoder, arrayLimit: 1000 });
  return mergeWith(withoutLists(defaults || {}), parsed, (_target, source) =>
    Array.isArray(source) ? source : undefined
  );
}
